import { RefreshAction, RefreshActionRef } from "./types";

export type RefreshControllerProps = {
  onActionsChanged: () => void;
};

export class RefreshController {
  prevRef: RefreshActionRef = 0;
  actions = new Map<RefreshActionRef, RefreshAction>();

  onActionsChanged;

  constructor({ onActionsChanged }: RefreshControllerProps) {
    this.onActionsChanged = onActionsChanged;
  }

  async refresh() {
    await Promise.all(this.actions.values().map((action) => action()));
  }

  register(action: RefreshAction) {
    const ref = this.prevRef++;
    this.actions.set(ref, action);
    this.onActionsChanged();
    return ref;
  }

  cleanup(ref: RefreshActionRef) {
    if (this.actions.has(ref)) {
      this.actions.delete(ref);
      this.onActionsChanged();
    }
  }
}
